export default "__VITE_ASSET__DlqMxwIO__"